'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var Loader = require('@pik-libs/loader');
var styled = require('styled-components');
var styles = require('@pik-libs/styles');
var utils = require('@pik-libs/utils');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Loader__default = /*#__PURE__*/_interopDefaultLegacy(Loader);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var _sizeByTheme;
var themes = utils.constants.themes;
var S = {};
var defaultSizes = {
  "default": {
    l: styled.css(["padding:0 24px;height:56px;", ";"], styles.typography.m),
    m: styled.css(["padding:0 24px;height:48px;", ";"], styles.typography.m),
    s: styled.css(["padding:0 16px;height:40px;", ";"], styles.typography.s)
  },
  round: {
    xl: styled.css(["width:56px;height:56px;"]),
    l: styled.css(["width:48px;height:48px;"]),
    m: styled.css(["width:40px;height:40px;.Icon{width:16px;height:16px;}"]),
    s: styled.css(["width:32px;height:32px;.Icon{width:16px;height:16px;}"]),
    xs: styled.css(["width:24px;height:24px;.Icon{width:16px;height:16px;}"])
  }
};
var testSizes = {
  "default": {
    l: styled.css(["padding:0 46px;height:89px;", ";"], styles.typography.m),
    m: styled.css(["padding:0 24px;height:48px;", ";"], styles.typography.m),
    s: styled.css(["padding:0 20px;height:46px;", ";"], styles.typography.s)
  },
  round: {
    xl: styled.css(["width:56px;height:56px;"]),
    l: styled.css(["width:48px;height:48px;"]),
    m: styled.css(["width:40px;height:40px;.Icon{width:16px;height:16px;}"]),
    s: styled.css(["width:32px;height:32px;.Icon{width:16px;height:16px;}"]),
    xs: styled.css(["width:24px;height:24px;.Icon{width:16px;height:16px;}"])
  }
};
var sizeByTheme = (_sizeByTheme = {}, _defineProperty(_sizeByTheme, themes.PIK_DEFAULT_THEME, defaultSizes), _defineProperty(_sizeByTheme, themes.TEST_THEME, testSizes), _sizeByTheme);
var stylesByType = {
  "default": function _default(_ref) {
    var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      size = _ref.size,
      themeName = _ref.themeName,
      backdropFilter = _ref.backdropFilter,
      borderRadius = _ref.borderRadius;
    return styled.css(["background-color:", ";color:", ";border-radius:", ";", ";", ""], backgroundColor || styles.colors.featureCard, color || styles.colors.black, borderRadius || '56px', sizeByTheme[themeName]["default"][size], backdropFilter && "backdrop-filter: blur(".concat(backdropFilter, ");"));
  },
  round: function round(_ref2) {
    var backgroundColor = _ref2.backgroundColor,
      color = _ref2.color,
      size = _ref2.size,
      themeName = _ref2.themeName,
      backdropFilter = _ref2.backdropFilter;
    return styled.css(["background-color:", ";color:", ";border-radius:100%;", ";", ""], backgroundColor || styles.colors.white, color || styles.colors.black, sizeByTheme[themeName].round[size], backdropFilter && "backdrop-filter: blur(".concat(backdropFilter, ");"));
  }
};
var commonStyles = styled.css(["cursor:pointer;overflow:hidden;position:relative;width:fit-content;", ";", ";z-index:1;", ";", ";", " ", " ", " &:after{content:'';", ";position:absolute;width:auto;height:auto;top:0;left:0;right:0;bottom:0;pointer-events:none;background:", ";opacity:0;z-index:-1;", ";", ";}", ";"], styles.mixins.flex(), styles.mixins.animation(), function (_ref3) {
  var type = _ref3.type,
    backgroundColor = _ref3.backgroundColor,
    color = _ref3.color,
    size = _ref3.size,
    backdropFilter = _ref3.backdropFilter,
    theme = _ref3.theme;
  return stylesByType[type]({
    backgroundColor: backgroundColor,
    color: color,
    size: size,
    backdropFilter: backdropFilter,
    themeName: theme.name || themes.PIK_DEFAULT_THEME
  });
}, function (_ref4) {
  var hoverOverlayOpacity = _ref4.hoverOverlayOpacity;
  return hoverOverlayOpacity && styled.css(["&:hover{&:after{opacity:", ";}}"], hoverOverlayOpacity);
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled && styled.css(["cursor:default;pointer-events:none;"]);
}, function (_ref6) {
  var fullWidth = _ref6.fullWidth;
  return fullWidth && styled.css(["width:100%;"]);
}, function (_ref7) {
  var shadow = _ref7.shadow;
  return shadow && styled.css(["filter:drop-shadow(0px 6px 7px rgba(0,0,0,0.1));"]);
}, function (_ref8) {
  var type = _ref8.type,
    backgroundColor = _ref8.backgroundColor,
    color = _ref8.color,
    size = _ref8.size,
    theme = _ref8.theme;
  return stylesByType[type]({
    backgroundColor: backgroundColor,
    color: color,
    size: size,
    themeName: theme.name || themes.PIK_DEFAULT_THEME
  });
}, styles.colors.black, styles.mixins.animation(), function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled && styled.css(["background:", ";opacity:0.8;"], styles.colors.featureCard);
}, function (_ref10) {
  var showBorderOnHover = _ref10.showBorderOnHover,
    borderColor = _ref10.borderColor;
  return showBorderOnHover && styled.css(["&:before{position:absolute;content:'';", ";width:auto;height:auto;top:0;left:0;right:0;bottom:0;pointer-events:none;background:transparent;border-width:1px;border-style:solid;border-color:", ";z-index:-1;backdrop-filter:none;opacity:0;", ";}&:hover{&:before{opacity:1;}}"], function (_ref11) {
    var type = _ref11.type,
      backgroundColor = _ref11.backgroundColor,
      color = _ref11.color,
      size = _ref11.size,
      theme = _ref11.theme;
    return stylesByType[type]({
      backgroundColor: backgroundColor,
      color: color,
      size: size,
      themeName: theme.name || themes.PIK_DEFAULT_THEME
    });
  }, borderColor || 'transparent', styles.mixins.animation('opacity'));
});
S.ButtonContainer = styled__default["default"].button.withConfig({
  displayName: "styles__ButtonContainer",
  componentId: "sc-1dk4kaq-0"
})(["", ";"], commonStyles);
S.ButtonContent = styled__default["default"].div.withConfig({
  displayName: "styles__ButtonContent",
  componentId: "sc-1dk4kaq-1"
})(function (_ref12) {
  var isLoading = _ref12.isLoading;
  return "\nopacity: ".concat(isLoading ? 0 : 1, ";\ndisplay: flex;\njustify-content: space-between;\nalign-items: center;\nflex-wrap: nowrap;\n");
});
S.ButtonLoader = styled__default["default"].div.withConfig({
  displayName: "styles__ButtonLoader",
  componentId: "sc-1dk4kaq-2"
})(function (_ref13) {
  var isLoading = _ref13.isLoading;
  return "\ndisplay: flex;\njustify-content: center;\nalign-items: center;\nposition: absolute;\ntop: 0;\nright: 0;\nleft: 0;\nbottom: 0;\nwidth: 100%;\nheight: 100%;\nopacity: ".concat(isLoading ? 1 : 0, ";\n");
});
S.LinkContainer = styled__default["default"].a.withConfig({
  displayName: "styles__LinkContainer",
  componentId: "sc-1dk4kaq-3"
})(["", ";"], commonStyles);
S.Prefix = styled__default["default"].div.withConfig({
  displayName: "styles__Prefix",
  componentId: "sc-1dk4kaq-4"
})(["margin-right:8px;.Icon{width:16px;height:16px;}"]);
S.Postfix = styled__default["default"].div.withConfig({
  displayName: "styles__Postfix",
  componentId: "sc-1dk4kaq-5"
})(["margin-left:8px;.Icon{width:16px;height:16px;}"]);

var loaderSizes = {
  s: 's',
  m: 'm'
};
var renderChildren = function renderChildren(_ref) {
  var children = _ref.children,
    prefix = _ref.prefix,
    postfix = _ref.postfix;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, prefix && /*#__PURE__*/React__default["default"].createElement(S.Prefix, null, prefix), children, postfix && /*#__PURE__*/React__default["default"].createElement(S.Postfix, null, postfix));
};
var Button = function Button(_ref2) {
  var id = _ref2.id,
    children = _ref2.children,
    type = _ref2.type,
    disabled = _ref2.disabled,
    fullWidth = _ref2.fullWidth,
    className = _ref2.className,
    backgroundColor = _ref2.backgroundColor,
    color = _ref2.color,
    onClick = _ref2.onClick,
    href = _ref2.href,
    targetBlank = _ref2.targetBlank,
    size = _ref2.size,
    backdropFilter = _ref2.backdropFilter,
    borderRadius = _ref2.borderRadius,
    shadow = _ref2.shadow,
    prefix = _ref2.prefix,
    postfix = _ref2.postfix,
    hoverOverlayOpacity = _ref2.hoverOverlayOpacity,
    showBorderOnHover = _ref2.showBorderOnHover,
    borderColor = _ref2.borderColor,
    loading = _ref2.loading,
    clickableOnLoading = _ref2.clickableOnLoading;
  var isLoading = clickableOnLoading ? false : loading;
  var props = {
    id: id,
    fullWidth: fullWidth,
    type: type,
    disabled: disabled,
    className: className,
    backgroundColor: backgroundColor,
    color: color,
    href: href,
    size: size,
    backdropFilter: backdropFilter,
    shadow: shadow,
    hoverOverlayOpacity: hoverOverlayOpacity,
    borderRadius: borderRadius,
    showBorderOnHover: showBorderOnHover,
    borderColor: borderColor
  };
  if (href) {
    if (targetBlank) {
      props = _objectSpread2(_objectSpread2({}, props), {}, {
        target: '__blank',
        rel: 'nofollow noopener'
      });
    }
    return /*#__PURE__*/React__default["default"].createElement(S.LinkContainer, _extends({
      href: href
    }, props), renderChildren({
      children: children,
      prefix: prefix,
      postfix: postfix
    }));
  }
  var loaderSize = loaderSizes[size] || 'm';
  return /*#__PURE__*/React__default["default"].createElement(S.ButtonContainer, _extends({
    onClick: onClick
  }, props), /*#__PURE__*/React__default["default"].createElement(S.ButtonLoader, {
    isLoading: isLoading
  }, /*#__PURE__*/React__default["default"].createElement(Loader__default["default"], {
    color: color,
    size: loaderSize
  })), /*#__PURE__*/React__default["default"].createElement(S.ButtonContent, {
    isLoading: isLoading
  }, renderChildren({
    children: children,
    prefix: prefix,
    postfix: postfix
  })));
};
Button.propTypes = {
  id: PropTypes__default["default"].string,
  children: PropTypes__default["default"].node.isRequired,
  type: PropTypes__default["default"].oneOf(['default', 'round']),
  disabled: PropTypes__default["default"].bool,
  fullWidth: PropTypes__default["default"].bool,
  className: PropTypes__default["default"].string,
  backgroundColor: PropTypes__default["default"].string,
  color: PropTypes__default["default"].string,
  href: PropTypes__default["default"].string,
  size: PropTypes__default["default"].string,
  backdropFilter: PropTypes__default["default"].string,
  borderRadius: PropTypes__default["default"].string,
  onClick: PropTypes__default["default"].func,
  targetBlank: PropTypes__default["default"].bool,
  shadow: PropTypes__default["default"].bool,
  prefix: PropTypes__default["default"].node,
  postfix: PropTypes__default["default"].node,
  hoverOverlayOpacity: PropTypes__default["default"].number,
  showBorderOnHover: PropTypes__default["default"].bool,
  borderColor: PropTypes__default["default"].string,
  loading: PropTypes__default["default"].bool,
  clickableOnLoading: PropTypes__default["default"].bool
};
Button.defaultProps = {
  id: undefined,
  type: 'default',
  disabled: false,
  fullWidth: false,
  targetBlank: false,
  shadow: false,
  backdropFilter: false,
  className: '',
  backgroundColor: '',
  borderRadius: '',
  color: '',
  href: null,
  size: 'm',
  onClick: function onClick() {},
  prefix: null,
  postfix: null,
  hoverOverlayOpacity: 0.04,
  showBorderOnHover: false,
  borderColor: null,
  loading: false,
  clickableOnLoading: false
};

module.exports = Button;
